import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { isGeneratingLicenseInitialState } from "./initialState";

const licenseGenerationReducer = (
  state: State.LicenseGenerationStatus = isGeneratingLicenseInitialState,
  action: PdApiActions
): State.LicenseGenerationStatus => {
  switch (action.type) {
    case PdApiActionsEnum.SET_LICENSE_GENERATION: {
      const generating = action.payload;
      return { ...state, isGeneratingLicense: generating };
    }
    default:
      return state;
  }
};

export default licenseGenerationReducer;
